import { Typography, Chip } from '@mui/material';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import type { Manufacturer } from '../../context/ManufacturerContext';

interface ManufacturerTableProps {
  manufacturers: Manufacturer[];
  loading: boolean;
  onView: (manufacturer: Manufacturer) => void;
}

export function ManufacturerTable({ manufacturers, loading, onView }: ManufacturerTableProps) {
  const columns = [
    { field: 'name', headerName: 'Nome', flex: 1 },
    { field: 'description', headerName: 'Descrição', flex: 1.5 },
    { 
      field: 'host', 
      headerName: 'Host', 
      width: 200,
      renderCell: (params: any) => (
        <Typography 
          sx={{ 
            fontFamily: 'monospace', 
            fontSize: 12,
            backgroundColor: '#F3F4F6',
            color: '#111827',
            px: 1,
            py: 0.5,
            borderRadius: 1
          }}
        >
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'port', 
      headerName: 'Porta', 
      width: 80,
      renderCell: (params: any) => (
        <Chip 
          label={params.value} 
          size="small"
          color="primary"
          variant="outlined"
        />
      )
    },
    { field: 'tenant_name', headerName: 'Empresa', flex: 1 },
  ];

  return (
    <DatabaseTable
      rows={manufacturers}
      columns={columns}
      loading={loading}
      onView={onView}
      hideDelete
      hideEdit
    />
  );
} 